<template>
<v-container container--fluid>
    <v-layout align-center justify-center>
        <v-flex xs12 sm12 md10>
            <v-card class="elevation-12">
                <v-toolbar flat dark color="primary">
                    <v-toolbar-title>Forgot / Reset Password</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-alert v-model.trim="alert" outlined transition="scale-transition" dismissible type="success">Email Sent Successfully</v-alert>
                    <v-form class="overwrite-inputs" ref="pwdform" v-model.trim="valid" lazy-validation>
                        <v-text-field placeholder="Username" prepend-icon="person" v-model.trim="username" :rules="usernameRules" :error="authErrors.has('username')" :error-messages="authErrors.get('username')" required></v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions class="pb-4">
                    <v-btn @click="clear" color="warning" :disabled="loginLoading" class="text-left">clear<v-icon right>clear</v-icon></v-btn>
                    <v-btn :loading="loginLoading" :disabled="!valid" color="primary" @click="sendPasswordResetEmail" class="text-left">Send Reset Link<v-icon right>send</v-icon></v-btn>
                </v-card-actions>
                <v-divider light></v-divider>
                <v-card-text>
                    <div class="text-center">
                        <router-link :to="{ name: 'username-email' }" class="mr-4"><v-btn small text color="primary">Forgot Username</v-btn></router-link>
                    </div>
                    <div class="text-center pt-2">
                        <span color="gray--text">Already have an account?</span> <router-link :to="{ name: 'login' }">Login</router-link>
                    </div>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</v-container>
</template>

<script>
export default {
    data(){
        return {
            'action':'password-email',
            'username':'',
            usernameRules: [
                v => !!v || 'Username is required',
            ],
            valid: true,
            alert: false
        }
    },
    computed: {
        authErrors(){
            return this.$store.getters['auth/authErrors'];
        },
        loginLoading(){
            return this.$store.getters['auth/authStatus'] == 'loading';
        }
    },
    methods: {
        clear () {
            this.alert = false;
            this.$refs.pwdform.reset();
            this.$store.dispatch('auth/clearErrors');
        },
        sendPasswordResetEmail: function () {
            if (this.$refs.pwdform.validate()) {
                this.valid = false;
                const { action, username} = this;
                this.$store.dispatch('auth/sendPwdEmail', { action, username })
                .then((resp) => {
                    // console.log(resp);
                    this.alert = true;
                    var _self = this;

                    setTimeout(function(){
                        _self.$router.push({ name: 'home'});
                    }, 3000);
                })
                .catch((err) => {
                    this.valid = true;
                    // console.log(err);
                });
            }
        }
    }
}
</script>
